export const INSTANCE_TYPE = {
  SPARE: 0,
  PERMANENT: 1,
  MAIN: 2,
  STREAM: 3,
};
